import React from "react";
import axios from "axios";
import moment from "moment";
import DatePicker from "react-datepicker";

export default class ReportFinance extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            notice: "",
            success: "",
        };
    }

    handleDateChange = (name, date) => {
        this.setState({
            [name]: date,
            notice: "",
            success: ""
        });
    };

    downloadReport = (e) => {
        e.preventDefault();
        let notice = "";
        let success = "";
        let url = null;

        if (!this.state.startDate || !this.state.endDate) {
            this.setState({
                "notice": "Zowel begin- als einddatum is vereist voor de periode",
                "success": "",
            });
            return;
        }

        url = `/v1/reports/finance/?date_after=${moment(this.state.startDate).format("YYYY-MM-DD")}&date_before=${moment(this.state.endDate).format(
            "YYYY-MM-DD"
        )}`;

        axios
            .get(url)
            .then((response) => {
                let message = "Het rapport wordt gegenereerd en per e-mail naar je verzonden.";
                if (response.data && response.data.message) {
                    message = response.data.message;
                }

                this.setState({
                    success: message
                });
            })
            .catch((error) => {
                console.log(error);
            });

        this.setState({
            notice,
            success
        });
    };

    render() {
        let notice = "";
        if (this.state.notice !== "") {
            notice = <div className="alert alert-warning">{this.state.notice}</div>;
        }
        let success = "";
        if (this.state.success !== "") {
            success = <div className="alert alert-success">{this.state.success}</div>;
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <h2>Financieel</h2>
                        {notice}
                        {success}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <DatePicker
                            name="startDate"
                            customInput={<input type="text" className="form-control" onClick={this.props.onClick} {...this.props.value} />}
                            onChange={(value) => this.handleDateChange("startDate", value)}
                            className="form-control"
                            required={false}
                            placeholderText="Datum vanaf (dd-mm-yyyy)"
                            selected={this.state.startDate}
                            autoComplete="off"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>
                    <div className="col-4">
                        <DatePicker
                            name="endDate"
                            customInput={<input type="text" className="form-control" onClick={this.props.onClick} {...this.props.value} />}
                            onChange={(value) => this.handleDateChange("endDate", value)}
                            className="form-control"
                            required={false}
                            placeholderText="Datum tot en met (dd-mm-yyyy)"
                            selected={this.state.endDate}
                            autoComplete="off"
                            minDate={moment(this.state.startDate)}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                    </div>

                    <div className="col-4">
                        <button className="btn btn-secondary" onClick={(e) => this.downloadReport(e)}>
                            Genereer rapport
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
